import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.CityBuilder;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "CityBuilder.Phaser.IntroductionScene.1",
            "CityBuilder.Phaser.IntroductionScene.2",
            "CityBuilder.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/CityBuilderGame/scenes/GameIntro.ts